import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { DriverLanguage } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class DriverLanguagesService extends BaseGetProvider<DriverLanguage> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices
  ) {
    super(http);
    this.delegate = this;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof DriverLanguage {
    return DriverLanguage;
  }

  get endpoint(): string {
    return this.endpointService.driverLanguage();
  }

  get isCachable(): boolean {
    return false;
  }
}
